import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RegistrationService {



  url = environment.serverAPI7 + "/api/ig/registration";

  url2 = environment.serverAPI7 + "/api/registration";

  url3 = environment.serverAPI7 + "/api";

  constructor(private http: HttpClient) { }

  getAllRegistration(Page: any, size: any, sort: any, type: any): Observable<Object> {
    return this.http.get(`${this.url}?page=${Page}&size=${size}&sort=${sort}&type=${type}`);
  }

  getAllRegistrationDropDown(): Observable<Object> {
    return this.http.get(`${this.url}/dropdown`);
  }

  getAllRegistrations(Page: number, size: number, sort: number): Observable<Object> {
    return this.http.get(`${this.url2}?page=${Page}&size=${size}&sort=${sort}`);
  }



  getRegistrationById(id: number): Observable<Object> {
    return this.http.get(`${this.url}/${id}`);
  }

  addOrEditRegistration(registration: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}`, registration);
  }

  RegistrationSearch(query, Page: any, size: any, sort: any, type: any): Observable<Object> {
    return this.http.get(`${this.url2}/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}&type=${type}`);
  }

  getAllRegistrationSearch(query: string, page: number, size: number, sort: string): Observable<Response[]> {


    const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null
    };

    const queryParams = `?page=${page}&size=${size}&sort=${sort}`;

    return this.http.post<Response[]>(`${this.url2}/filter/condition${queryParams}`, requestBody);
  }

  getAllRegistrationByPlan(Page: any, size: any, sort: any, type: any): Observable<Object> {
    if(type == undefined || type == null){
      type = 22
    }
    return this.http.get(`${this.url3}/ig/sequence/registration?page=${Page}&size=${size}&sort=${sort}&plan=${type}`);
  }

  getAllRegistrationSearchByPlan(query: string, page: number, size: number, sort: string ,additionalQuery:any): Observable<Response[]> {

    const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null,
      "additionalQuery":additionalQuery
    };

    const queryParams = `?page=${page}&size=${size}&sort=${sort}`;

    return this.http.post<Response[]>(`${this.url3}/ig/sequence/registration/filter/condition${queryParams}`, requestBody);
  }

}
